import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from "../../../../shared/services/api/api.service";
import {ISystemParameterGroup} from "../models/system-parameter-group";

@Injectable({
  providedIn: 'root'
})
export class SystemParameterGroupService {

  constructor(private readonly apiService: ApiService) {
  }

  getList(): Observable<ISystemParameterGroup[]> {
    return this.apiService.get<ISystemParameterGroup[]>('parameter-group');
  }

  getParametersByGroup(groupId: number): Observable<ISystemParameterGroup> {
    return this.apiService.get<ISystemParameterGroup>(`parameter-group/${groupId}/parameters`);
  }

  create(group: ISystemParameterGroup): Observable<ISystemParameterGroup> {
    return this.apiService.post<ISystemParameterGroup>('parameter-group/create', group);
  }

  update(group: ISystemParameterGroup): Observable<ISystemParameterGroup> {
    return this.apiService.patch<ISystemParameterGroup>('parameter-group/update', group);
  }

  delete(groupId: number): Observable<any> {
    return this.apiService.delete<any>(`parameter-group/delete/${groupId}`);
  }
}
